






















import { Component, Vue, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import { DxTreeList, DxSelection, DxColumn } from 'devextreme-vue/tree-list';
import { AddProgressStatementDataCommand, ProgressStatementsClient, IProgressStatementSelectionDataDto } from '@/data/web-api-client';
@Component({
  components: {
    DxTreeList,
    DxSelection,
    DxColumn,
    Popup,
  },
})
export default class ProgressStatementAddDataDialog extends Vue {
  @Prop({ required: true })
  documentNumber!: string;
  @Prop({ required: true })
  versionNumber!: number;
  client: ProgressStatementsClient = new ProgressStatementsClient(undefined, this.$axios);
  saving: boolean = false;
  show: boolean = false;
  loading: boolean = false;
  progressStatementGenerationModel: any = {
    projectId: null,
    measurementNames: null,
    progressStatementId: null,
  };
  items: IProgressStatementSelectionDataDto[] = [];

  public open() {
    this.show = true;
  }

  created() {
    this.loadData();
  }

  public async loadData() {
    try {
      this.loading = true;
      this.items = await this.client.getProjectData(this.mergedDocumentNumber.replaceAll('/', '-'));
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  async save() {
    try {
      this.saving = true;
      let selectedRows = this.treelist.getSelectedRowsData();

      //Whole measuringstate is selected => only select children, otherwhise whole measuringstate gets processed
      if (selectedRows.length === 1 && !selectedRows[0].parentId) {
        selectedRows = this.items.filter((i) => i.parentId === selectedRows[0].id);
      }

      await this.client.addData(
        this.mergedDocumentNumber.replaceAll('/', '-'),
        new AddProgressStatementDataCommand({
          documentNumber: this.mergedDocumentNumber,
          data: selectedRows,
        })
      );
      this.$emit('saved');
      this.show = false;
      notificationService.saved();
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.saving = false;
    }
  }

  get mergedDocumentNumber() {
    return `${this.documentNumber}-${this.versionNumber}`;
  }

  get treelist() {
    return (this.$refs.treeList as any).instance;
  }
}
